import { render, staticRenderFns } from "./DisplayUsers.vue?vue&type=template&id=2cd7cefc"
import script from "./DisplayUsers.vue?vue&type=script&lang=js"
export * from "./DisplayUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cd7cefc')) {
      api.createRecord('2cd7cefc', component.options)
    } else {
      api.reload('2cd7cefc', component.options)
    }
    module.hot.accept("./DisplayUsers.vue?vue&type=template&id=2cd7cefc", function () {
      api.rerender('2cd7cefc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/DisplayUsers.vue"
export default component.exports